import { GenericKeyBookmarksGroupOperator } from './operators/generic-key-bookmarks-group.operator';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopupControl } from 'src/app/models/popup-control.model';
import { NotificationService } from 'src/app/services/notification.service';

import { Bookmark } from './models/bookmark.model';
import { BookmarksGroupOperator } from './operators/bookmarks-group.operator';

import { Subscription, firstValueFrom } from 'rxjs';
import { BookmarkElementsOperator } from './operators/elements-operators/bookmark-elements.operator';
import { UtilsService } from 'src/app/services/utils.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxPopupModule, DxScrollViewModule, DxTextAreaModule, DxLoadPanelModule, DxDataGridModule,  DxRadioGroupModule, DxDataGridComponent } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { ControlPopUpModule } from '../control-pop-up/control-pop-up.module';
import { CreateBookmarkPopUpComponent } from './create-bookmark-pop-up/create-bookmark-pop-up.component';
import { StatusMessageResultDto } from 'src/app/pages/general/project.service';
import { SelectStatementResult } from 'src/app/models/select-statement-result.model';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';

/**
 * The `BookmarkNewComponent` displays a bookmark button for a given page and instance.
 *
 * The component expects a `instanceIdentifier` attribute on its root element, which specifies the instance identifier.
 * It also expects the `routeId` to be provided as a route data parameter.
 *
 * The component expects a `bookmarkElementsOperators` attribute on its root element, which specifies the operators that apply and prepare data for the bookmark.
 *
 * The component computes a perfect hash value using the `computeRouteHash` method to combine the `routeId` and `uId` into a single identifier.
 * The identifier is used to set the bookmark's `id` attribute, allowing it to be linked to the operator that handles requests of data from backend.
 */
@Component({
    selector: 'app-bookmark-new',
    imports: [
        CommonModule,
        ControlPopUpModule,
        CreateBookmarkPopUpComponent,
        DevEpressCommonModule,
        DxPopupModule,
        DxScrollViewModule,
        DxTextAreaModule,
        DxLoadPanelModule,
        DxDataGridModule,
        // DxCheckBoxModule,
        DxScrollViewModule,
        DxRadioGroupModule,
        FormsModule,
        ReactiveFormsModule
    ],
    templateUrl: './bookmark-new.component.html',
    styleUrls: ['./bookmark-new.component.scss'],
	standalone: true
})
export class BookmarkNewComponent implements OnInit {

	public bookmarksTablePopupControl: PopupControl = new PopupControl(
		{
			title: 'Bookmarks',
			width: 600,
			height: '60%',
			minHeight: 600
		}
	);

	public createBookmarkPopupControl: PopupControl = new PopupControl(
		{
			title: 'Create Bookmark',
			width: 500,
			height: 'auto',
		}
	);

	public selectedBookmark: Bookmark;

	@ViewChild('dataGrid', { static: false })
	public dxDataGrid: DxDataGridComponent;

	private onBookmarkAppliedSubscription: Subscription;

	@Output()
	public bookmarksGroupOperatorChange: EventEmitter<BookmarksGroupOperator> = new EventEmitter<BookmarksGroupOperator>();

	private _bookmarksGroupOperatorLoadPromise: Promise<SelectStatementResult<Bookmark>>;

	private _bookmarksGroupOperator: BookmarksGroupOperator;
	public get bookmarksGroupOperator(): BookmarksGroupOperator {
		return this._bookmarksGroupOperator;
	}
	@Input()
	public set bookmarksGroupOperator(value: BookmarksGroupOperator) {
		if (this.onBookmarkAppliedSubscription) {
			this.onBookmarkAppliedSubscription.unsubscribe();
		}

		this._bookmarksGroupOperator = value;

		this.bookmarksGroupOperatorChange.emit(this._bookmarksGroupOperator);

		if (this._bookmarksGroupOperator) {
			this.onBookmarkAppliedSubscription = this._bookmarksGroupOperator.onBookmarkApplied.subscribe(
				{
					next: (bookmark: Bookmark) => {
						

						this.selectedBookmark = bookmark;
						
					}
				}
			);

			this._bookmarksGroupOperator.getObservable().then(
				(observable$) => {
					this._bookmarksGroupOperatorLoadPromise = firstValueFrom(observable$);
				}
			);

			// this._bookmarksGroupOperator.getObservable(
			// 	{
			// 		name: 'Bookmarks Group Operator Loading',
			// 		responseLoggingEnabled: true,
			// 	}
			// ).then(
			// 	(promiseResponse) => {
			// 		promiseResponse.subscribe(
			// 			{
			// 				next: (bookmarksSSR: SelectStatementResult<Bookmark>) => {

			// 				}
			// 			}
			// 		)
			// 	}
			// );
		}
	}

	private _bookmarksToBeRemoved: Bookmark[] = [];

	public onRowRemoved(evt: any): void {
		

		const bookmark: Bookmark = <Bookmark>evt.data;

		this._bookmarksToBeRemoved.push(bookmark);
	}

	private _bookmarksToBeUpdated: Bookmark[] = [];

	public onRowUpdated(evt: any): void {
		

		const bookmark: Bookmark = <Bookmark>evt.data;

		this._bookmarksToBeUpdated.push(bookmark);
	}

	public onSaved(evt: any): void {
		

		//TODO: consider creating a request that accepts multiple bookmarks for deletion and update.

		for (let a = 0; a < this._bookmarksToBeRemoved.length; a++) {
			const bookmark: Bookmark = this._bookmarksToBeRemoved[a];

			this.bookmarksGroupOperator.deleteBookmark(bookmark);
		}

		for (let a = 0; a < this._bookmarksToBeUpdated.length; a++) {
			const bookmark: Bookmark = this._bookmarksToBeUpdated[a];

			this.bookmarksGroupOperator.updateBookmark(bookmark);
		}

		this._notificationService.success('Bookmarks group successfully modified.');
	}

	public changeDefaultBookmark(evt: any): void {
		const bookmark: Bookmark = <Bookmark>evt.data;

		

		this.dxDataGrid.instance.beginUpdate();

		for (let a = 0; a < this.bookmarksGroupOperator.bookmarks.length; a++) {
			const element = this.bookmarksGroupOperator.bookmarks[a];

			if (element !== bookmark && element.isDefault) {
				element.isDefault = false;

				
			} else if (element === bookmark) {
				element.isDefault = true;

				this.bookmarksGroupOperator.updateBookmark(element).then(
					(statusMessageResult: StatusMessageResultDto) => {
						if (statusMessageResult.success) {
							this._notificationService.success(
								statusMessageResult.message,
								200
							);
						}
					}
				);

				
			}
		}

		this.dxDataGrid.instance.endUpdate();

		
	}

	public removeDefaultBookmark(evt: any): void {
		const bookmark: Bookmark = <Bookmark>evt.data;

		this.dxDataGrid.instance.beginUpdate();

		bookmark.isDefault = false;

		this.bookmarksGroupOperator.updateBookmark(bookmark).then(
			(statusMessageResult: StatusMessageResultDto) => {
				if (statusMessageResult.success) {
					this._notificationService.success(
						statusMessageResult.message,
						200
					);
				}
			}
		);

		this.dxDataGrid.instance.endUpdate();
	}

	public async applyDefaultBookmark(): Promise<boolean> {
		await this._bookmarksGroupOperatorLoadPromise;

		let bookmark: Bookmark = this._bookmarksGroupOperator.bookmarks.find(
			(bookmark) => bookmark.isDefault
		);

		this._loadingIndicationService.unlockLoading();

		return bookmark ? this._bookmarksGroupOperator.applyBookmark(bookmark) : false;
	}

	@Input()
	public instanceIdentifier: number = null;

	private _bookmarkElementsOperators: BookmarkElementsOperator[] = null;
	public get bookmarkElementsOperators(): BookmarkElementsOperator[] {
		return this._bookmarkElementsOperators;
	}
	@Input()
	public set bookmarkElementsOperators(value: BookmarkElementsOperator[]) {
		this._bookmarkElementsOperators = value;

		if (this.bookmarksGroupOperator) {
			this.bookmarksGroupOperator.bookmarkElementsOperators = this._bookmarkElementsOperators;
		}
	}

	@Input()
	public initializeWithGenericOperator: boolean = true;

	/**
	 * The private identifier for the boomark, computed from the `routeId` and `uId`.
	 */
	private _identifier: number;

	/**
	 * The private numeric identifier of the page.
	 */
	private _routeId: number;

	constructor(
		// private _bookmarkService: BookmarkService,
		private _notificationService: NotificationService,
		// private _elementRef: ElementRef,
		private _activatedRoute: ActivatedRoute,
		// private _bookmarkService: BookmarkService,

		private _loadingIndicationService: LoadingIndicationService,
	) { }

	/**
	 * Initializes the component by computing the `identifier` using the `computeRouteHash` method.
	 * This method subscribes to the `route.data` observable to obtain the `routeId`.
	 */
	ngOnInit() {
		

		if (this.instanceIdentifier === null) throw new Error('The "instanceIdentifier" property is mandatory and must be provided.');
		if (this.bookmarkElementsOperators === null) throw new Error('The "bookmarkElementsOperators" property is mandatory and must be provided.');

		

		// Assuming the route data contains the `routeId`.
		this._activatedRoute.data.subscribe(
			(data) => {
				this._routeId = data.id;

				

				this._identifier = UtilsService.computeRouteHash(this._routeId, this.instanceIdentifier);

				

				if (this.initializeWithGenericOperator) {
					if (this.bookmarksGroupOperator) {
						console.warn('`bookmarksGroupOperator` is being initialized with `GenericKeyBookmarksGroupOperator` but it had a value before.');
					}

					this.bookmarksGroupOperator = new GenericKeyBookmarksGroupOperator(
						this._identifier,
						this._routeId,
						() => this.bookmarkElementsOperators
					);
				}
			}
		);
	}
}
